import * as _ from 'lodash';

export type PermissionType = string | { _: string };

export class User {
    id: number;
    userName: string;
    fullName: string;
    email: string;
    active: true;
    organization: any;
    roles: any[];
    isSystemUser: boolean;
    language: { id: string };
    hasAnyNotifications: boolean;

    private readonly allPermissions: string[];
    private readonly collaborationRoles: string[];
    private readonly allRoles: string[];
    private readonly cache: { [permission: string]: boolean; } = {};

    constructor(data: any) {
        Object.assign(this, data);
        const userRoles = _.flatMap(this.roles, x => x.role);
        const organizationRoles = this.organization ? _.flatMap(this.organization.roles, x => x.role) : [];
        const roles = _.uniq([...userRoles, ...organizationRoles]);
        this.collaborationRoles = this.organization ? _.map(_.flatMap(this.organization.collaborationRoles, x => x.collaborationRole), x => x.id) : [];
        this.allRoles = _.map(roles, x => x.name);
        this.allPermissions = _.uniq(_.map(_.flatMap(roles, x => x.permissions), x => `${x.permission.module}.${x.permission.namespace}.${x.permission.name}`));
        _.forEach(_.filter(this.allPermissions, x => x), ((x: string) => {
            const temp = x.split('.');
            this.cache[`${temp[0]}`] = true;
            this.cache[`${temp[0]}.${temp[1]}`] = true;
            if (temp.length > 2) {
                this.cache[`${temp[0]}.${temp[2]}`] = true;
            }

            this.cache[x] = true;
        }));
    }

    hasPermission(...permissions: PermissionType[]) {
        if (this.isSystemUser) {
            return this.isSystemUser;
        }

        const perms = _.map(permissions, (x: PermissionType) => _.isString(x) ? x : (x)._);

        return _.some(perms, y => {
            return this.cache[y];
        });
    }

    hasRole(role: string) {
        return _.includes(this.allRoles, role);
    }

    hasCollaborationRole(collaborationRole: string) {
        return _.includes(this.collaborationRoles, collaborationRole);
    }
}
